import { render } from "./KappInfocenter.vue?vue&type=template&id=96e8cf24&scoped=true"
import script from "./KappInfocenter.vue?vue&type=script&lang=js"
export * from "./KappInfocenter.vue?vue&type=script&lang=js"

import "./KappInfocenter.vue?vue&type=style&index=0&id=96e8cf24&scoped=true&lang=css"

import exportComponent from "/home/jbenes/PhpstormProjects/VUE/VUE_Neustadt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96e8cf24"]])

export default __exports__